import { PropsWithChildren } from "react";

export function Container({ children }: PropsWithChildren) {
  return <main className={"grow flex flex-col"}>{children}</main>;
}
